import React, { useState, useRef, memo } from 'react';
import { render, createPortal } from 'react-dom';
import { useXFlowApp } from '@antv/xflow-core';
import { Button } from 'antd';
import { SketchPicker } from 'react-color';
import { PREFIX } from '../constants';
const ColorPicker = props => {
    const { label, value = '', onChange } = props;
    const [show, setShow] = useState(false);
    const colorRef = useRef(value);
    const { graphProvider } = useXFlowApp();
    const graphConfig = useRef();
    graphProvider.getGraphOptions().then(x6GraphConfig => {
        graphConfig.current = x6GraphConfig;
    });
    const PickContainer = () => {
        return (React.createElement("div", { className: `${PREFIX}-pick-color-container` },
            React.createElement("div", { className: `${PREFIX}-popover` },
                React.createElement(SketchPicker, { onChange: color => {
                        colorRef.current = color.hex;
                    } }),
                React.createElement("div", { className: "foolter" },
                    React.createElement(Button, { onClick: () => {
                            setShow(false);
                        } }, "\u53D6\u6D88"),
                    React.createElement(Button, { type: "primary", onClick: () => {
                            onChange === null || onChange === void 0 ? void 0 : onChange(colorRef.current);
                            setShow(false);
                        } }, "\u786E\u8BA4")))));
    };
    const createPickColorContainer = (visible) => {
        const existElements = document.getElementsByClassName(`${PREFIX}-pick-color-container`);
        if (existElements.length) {
            Array.from(existElements).forEach(ele => {
                var _a;
                (_a = ele.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(ele);
            });
        }
        if (!visible) {
            return;
        }
        const div = document.createElement('div');
        render(createPortal(React.createElement(PickContainer, null), document.getElementsByTagName('body')[0]), div);
    };
    return (React.createElement("div", { className: "group" },
        label && React.createElement("label", null, label),
        React.createElement("div", { className: `${PREFIX}-color-container`, onClick: () => {
                setShow(true);
            } },
            React.createElement("div", { className: `${PREFIX}-color`, style: {
                    backgroundColor: value,
                    height: '100%',
                } })),
        createPickColorContainer(show)));
};
export default memo(ColorPicker, (pre, next) => {
    return pre.label === next.label && pre.value === next.value;
});
//# sourceMappingURL=color.js.map